module.exports = __webpack_public_path__ + "media/images/media-elements/pause-56840f821cf1972616874e2f925421ec.svg";